import { SxProps, Theme } from '@mui/material';

/*
 * The step chrome is the signed-in booking page's own, re-exported rather than copied, so the
 * two ways of booking cannot drift apart in how a step looks.
 */
export {
    confirmRowStyles,
    emptyStateStyles,
    headerBoxStyles,
    loadingBoxStyles,
    requestHintStyles,
    selectFieldStyles,
    stepBoxStyles,
    stepTitleStyles,
    subtitleStyles,
    titleStyles,
} from '../AppointmentBookingForm/appointmentBookingForm.styles';

export const noteFieldStyles: SxProps<Theme> = {
    mt: 3,
};

/** Said before anybody types anything: the hour is not theirs until they confirm by email. */
export const notReservedHintStyles: SxProps<Theme> = {
    mb: 2,
};
